import React from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import { useLocation } from 'react-router';
import 'simplebar/dist/simplebar.css';
import { ButtonSize, ButtonType } from '@bimone/bimtrackreactcomponents';
import { useTranslation } from 'react-i18next';
import { StyledErrorPage } from './styles';

interface Props {
  error?: Error;
  resetErrorBoundary?: () => void;
}

interface LocationState {
  state: Props;
}

export default function ErrorPage({ error: errorProp, resetErrorBoundary }: Props): JSX.Element {
  const { state } = useLocation() as LocationState;
  const { t } = useTranslation('errorPage');
  const error = errorProp ?? state.error;
  const {
    Background,
    Container,
    Logo,
    Title,
    ErrorContainer,
    ErrorDetailContainer,
    ErrorType,
    ErrorMessage,
    StackTraceContainer,
    StackTrace,
    ContinueButton,
  } = StyledErrorPage;

  return (
    <Background>
      <Container>
        <Logo />
        <Title>{t('title')}</Title>
        {error && (
          <ErrorContainer>
            <ErrorDetailContainer>
              <ErrorType>{error.name}:</ErrorType>
              <ErrorMessage>{error.message}</ErrorMessage>
            </ErrorDetailContainer>
            <StackTraceContainer>
              <AutoSizer>
                {({ width, height }) => <StackTrace style={{ width, height }}>{error.stack}</StackTrace>}
              </AutoSizer>
            </StackTraceContainer>
          </ErrorContainer>
        )}
        {resetErrorBoundary && (
          <ContinueButton
            label={t('continue') ?? ''}
            onClick={resetErrorBoundary}
            size={ButtonSize.MEDIUM}
            type={ButtonType.PRIMARY}
          />
        )}
      </Container>
    </Background>
  );
}
